import {Fragment, useEffect, useState} from "react";
import {BreadCrumb, Tooltip, DropdownAction, Table, CenteredModal, ToastNotification, MediaLightbox} from "~/components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faCloudArrowUp, faTableCellsLarge, faList, faXmark, faDownload, faTrash, faCircleInfo, faEdit,
    faCopy
} from "@fortawesome/free-solid-svg-icons";
import FileManagerApi from "~/api/fileManagerApi";
import {format} from "date-fns";
import commonApi from "~/api/commonApi";
const breadCrumbItem = [
    { text: "Home", to: "/ai-chatbot/administrator", isActive: false },
    { text: "File Manager", to: "", isActive: true },
]
const apiUrl = process.env.REACT_APP_API_URL;
const tableConfig = {
    columns: [
        {
            name: "Test",
            width: "50px",
            type: "checkbox",
            template: (row) => {
                return (
                    <div className="form-check fs-8 mb-0">
                        <input className="form-check-input" type="checkbox"/>
                    </div>
                )
            }
        },
        {
            name: 'NAME',
            width: '350px',
            template: function(row){
                return (
                    <a className="d-flex align-items-center gap-3 fw-semibold text-body-highlight " href="/apps/file-manager/grid-view#!" data-discover="true">
                        <div className="square-icon-box border border-translucent overflow-hidden position-relative">
                            <img className="w-100 h-100 pointer-events-none" alt="" src={row.FileUrl} style={{aspectRatio: "16 / 9"}}/>
                        </div>
                        <p className="mb-0">{row.FileName}</p>
                    </a>
                )
            }
        },
        {
            name: 'CREATED DATE',
            width: '200px',
            key: 'CreatedDate',
            template: (row) => {
                return (
                    format(new Date(row.CreatedDate), "dd/MM/yyyy hh:mm:ss a")
                )
            }
        },
        {
            name: 'FILE SIZE',
            width: '100px',
            key: 'SizeReadable'
        }
    ],
    data : []
}
function FileManager() {
    const [fileManager, setFileManager] = useState([]);
    const [viewMode, setViewMode] = useState(1);
    const [selectedFile, setSelectedFile] = useState([]);
    const [messageInfo, setMessageInfo] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [showToastNoti, setShowToastNoti] = useState(false);
    const [reloadData, setReloadData] = useState(false);
    const [lightboxSrc, setLightboxSrc] = useState('');
    const [lightboxToggler, setLightboxToggler] = useState(false);


    useEffect(() => {
        FileManagerApi.getAll()
            .then((res) => {
                setFileManager(res.data);
            })
            .catch((err) => {
                ;
            })
    }, [reloadData])

    const handleSelectedFileChange = (fileName) => {
        setSelectedFile((prevSelected) => {
            if (prevSelected.includes(fileName)) {
                return prevSelected.filter((f) => f !== fileName);
            }
            return [...prevSelected, fileName];
        });
    }

    const handleUploadFile = (event) => {
        const file = event.target.files[0];
        if (!file) return;
        const formData = new FormData();
        formData.append("file", file);
        FileManagerApi.uploadFile(formData)
            .then((res) => {
                setReloadData(prev => !prev);
                setMessageInfo(res.data.Message);
                setShowToastNoti(prev => !prev);
            })
            .catch((err) => {
                setMessageInfo(err.response.data.Message);
                if(err.status === 409){
                    setShowModal(true);
                }
                else{
                    setShowToastNoti(prev => !prev);
                }
            })
    };

    const handleConfirmOverride = () => {

    }

    const handleDeleteFile = (fileName) => {
        FileManagerApi.deleteFile(fileName ? [fileName] : selectedFile)
            .then((res) => {
                setReloadData(prev => !prev);
                setShowToastNoti(prev => !prev);
                setMessageInfo(res.data.Message);
                setSelectedFile([]);
            })
            .catch((err) => {
                ;
            })
    }

    const handleDownloadFile = async (fileName) => {
        commonApi.getUploadFile(fileName)
            .then((res) => {
                const url = window.URL.createObjectURL(res.data);
                const a = document.createElement("a");
                a.href = url;
                a.download = fileName; // tên file tải về
                document.body.appendChild(a);
                a.click();
                a.remove();
            })
            .catch(() => {
            });
    }

    const handleClickXmark = () => {
        setSelectedFile([]);
        document.querySelectorAll('.img-checkbox').forEach(cb => cb.checked = false);
    }

    const handleCopyLink = async (fileUrl) => {
        try {
            await navigator.clipboard.writeText(fileUrl);
        } catch (err) {
            ;
        }
    }

    const handleOpenLightbox = (src) => {
        setLightboxSrc(src);
        setTimeout(() => {
            setLightboxToggler(prev => !prev);
        }, 50);
    }

    return (
        <Fragment>
            <BreadCrumb breadCrumbItem={breadCrumbItem}/>
            <h2 className="text-bold text-body-emphasis mb-3">File Manager</h2>
            <input id="fileUpload" className="d-none" type="file" onChange={handleUploadFile}/>
            <label htmlFor="fileUpload">
                    <span role="button" tabIndex="0" type="button" className="px-sm-6 btn btn-bt-primary">
                        <FontAwesomeIcon icon={faCloudArrowUp} className="me-2"/>
                    Upload New File </span>
            </label>
            <div className="card mt-4">
                <div className="py-3 px-4 card-header">
                    <div className="g-3 flex-between-center row">
                        <div className="col-auto"><h5 className="mb-0">My Files</h5></div>
                        <div className="d-flex col-auto">
                            <Tooltip placement="top" text="Grid view">
                                <button onClick={() => setViewMode(1)} type="button" className= {`btn-square me-2 btn btn-bt-secondary ${viewMode === 1 ? "border-primary text-primary" : ""}`}>
                                    <FontAwesomeIcon icon={faTableCellsLarge}/>
                                </button>
                            </Tooltip>
                            <Tooltip placement="top" text="List view">
                                <button onClick={() => setViewMode(2)} type="button" className= {`btn-square me-2 btn btn-bt-secondary ${viewMode === 2 ? "border-primary text-primary" : ""}`}>
                                    <FontAwesomeIcon icon={faList}/>
                                </button>
                            </Tooltip>
                            <select className="form-select mx-2 mx-sm-3 form-select">
                                <option>Sort by - Date created</option>
                                <option>Sort by - Name</option>
                                <option>Sort by - Size</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div className="pt-0 card-body">
                    <div className="myfiles-action-bar mx-n4 mb-4">
                        {
                            selectedFile.length > 0 ?
                                (
                                    <div id="file-manager-actions" className="d-block">
                                        <div className="d-flex align-items-center">
                                            <button className="btn p-0 fs-8 me-2 me-sm-3" onClick={handleClickXmark}>
                                                <FontAwesomeIcon icon={faXmark}/>
                                            </button>
                                            <h6 className="mb-0 me-4 text-nowrap text-body-tertiary">{selectedFile.length} item selected</h6>
                                            <div className="d-flex gap-1 gap-sm-2">
                                                <button type="button" onClick = {() => handleDeleteFile()}
                                                        className="fs-10 btn-square-sm d-none d-sm-block btn btn-bt-secondary">
                                                    <FontAwesomeIcon icon={faTrash}/>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                )
                                :
                                (
                                    <h6 className="mb-0 text-body-tertiary" id="file-manager-replace-element"> Total {fileManager.length} items</h6>
                                )
                        }
                        <button type="button" className="fs-10 btn-square-sm btn btn-bt-secondary">
                            <FontAwesomeIcon icon={faCircleInfo}/>
                        </button>
                    </div>
                    <div className="gx-xxl-9 row">
                        {
                            viewMode === 1 && (
                                <div className="col">
                                    <div className="files-container">
                                        {
                                            fileManager.map((file, index)  => (
                                                <div key={index} className="text-center">
                                                    <div className="file-box-wrapper img-zoom-hover" onDoubleClick={() => handleOpenLightbox(file.FileUrl)}>
                                                        <input id={index} className="img-checkbox form-check-input-transparent position-absolute top-0 start-0 mt-3 ms-3 z-1 form-check-input"
                                                               type="checkbox" name={index} onChange={() => handleSelectedFileChange(file.FileName)}/>
                                                        <label htmlFor={index} className="cursor-pointer stretched-link position-absolute top-0 start-0 w-100 h-100 form-check-label"></label>
                                                        <div className="position-relative h-100">
                                                            <div className="file-box overflow-hidden">
                                                                <img alt="" className="w-100 h-100 object-fit-cover" src={file.FileUrl}/>
                                                            </div>
                                                        </div>
                                                        <div className="lh-1 position-absolute top-0 end-0 mt-2 me-2 dropdown">
                                                            <DropdownAction dropdownItems={[
                                                                { text: "Download", icon: faDownload, onClick: () => handleDownloadFile(file.FileName) },
                                                                { text: "Rename", icon: faEdit },
                                                                {
                                                                    text: "Delete",
                                                                    className: "text-danger",
                                                                    icon: faTrash,
                                                                    onClick: () => handleDeleteFile(file.FileName)
                                                                },
                                                                {text: "Copy link", icon: faCopy, onClick: () => handleCopyLink(file.FileUrl)}
                                                            ]} isVerticalIcon={true}/>
                                                        </div>
                                                        <a className="d-block fw-bold text-body-highlight mt-2 text-nowrap text-truncate fs-9 fs-sm-9"
                                                           href="/apps/file-manager/grid-view#!" data-discover="true">{file.FileName}</a>
                                                        <h6 className="mb-0 fw-semibold text-body-tertiary fs-10 fs-sm-10">{file.SizeReadable}</h6>
                                                    </div>
                                                </div>
                                            ))
                                        }
                                        <MediaLightbox src={lightboxSrc} toggler={lightboxToggler} />
                                    </div>
                                </div>
                            )
                        }
                        {
                            viewMode === 2 && (
                                <div className="my-files-table col">
                                    <div className="scrollbar ms-n1 ps-1">
                                        <Table tableConfig={{...tableConfig, data: fileManager}}/>
                                    </div>
                                </div>
                            )
                        }

                    </div>
                </div>
            </div>
            <CenteredModal title="Override file confirm" show={showModal} onClose={() => setShowModal(false)} confirmText="Confirm" onConfirm={handleConfirmOverride}>
               <span className="fs-8-1 fw-bold">{messageInfo}</span>
            </CenteredModal>
            <ToastNotification message={messageInfo} show={showToastNoti} />
        </Fragment>
    )
}

export default FileManager;